import { makeVar } from '@apollo/client';
import { DEFAULT_TIMEZONE } from './constants';

export const timeZoneVar = makeVar<string>(DEFAULT_TIMEZONE);
